import { getMe } from 'api/auth';
import RegisterForm, {
  OptionalLabel,
  OptionalRegisterFormFieldElements,
} from 'components/authentication/RegisterForm';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import {
  fetchUtmParamsJoinedWithFbDataFromLocalStorage,
  trackFreemiumPurchase,
} from 'utils/analytics/analytics';
import { ASSET_PREFIX } from 'utils/constants';
import { getCookie } from 'utils/cookie';
import s from './PlayFreeSignUpAndEnter.module.css';
import { useEffect } from 'react';

const PlayFreeSignUpAndEnter = observer(
  ({ desktopView = false }: { desktopView?: boolean }) => {
    const { currentUser } = useUserStore();

    const router = useRouter();
    // See ENG-415
    useEffect(() => {
      router.push('/enter?em=FreeSubscription');
    });

    return <></>
    /*
    const handleStartFreeSubscription = async () => {
      const jwt = getCookie('jwt');
      const utmParams = fetchUtmParamsJoinedWithFbDataFromLocalStorage();
      const affiliateFutureAffc = getCookie('Affc', null);
      const result = await createFreeSubscription(
        jwt,
        utmParams,
        undefined,
        affiliateFutureAffc
      );

      if (result.successful === false) {
        alert(result.reason);
        return;
      }

      const userId = (currentUser ?? (await getMe(jwt))).id;

      trackFreemiumPurchase(result.freeSubscriptionId, userId);

      router.push(
        `/confirmation?freeSubscriptionId=${result.freeSubscriptionId}`
      );
    };

    const getRegisterForm = () => (
      <RegisterForm
        preselectAgreedToTerms
        submitButtonTitle="Enter now"
        completionHandler={async (token: string) => {
          handleStartFreeSubscription();
        }}
        excludeFormFieldsList={[
          OptionalRegisterFormFieldElements.PHONE_NUMBER,
          OptionalRegisterFormFieldElements.DATE_OF_BIRTH,
        ]}
        excludeLabelsList={[
          OptionalLabel.FIRST_NAME,
          OptionalLabel.LAST_NAME,
          OptionalLabel.EMAIL_ADDRESS,
          OptionalLabel.CREATE_PASSWORD,
        ]}
        alwaysShowAgeGuidance={false}
        alwaysShowPasswordGuidance={false}
        showCheckboxes={false}
        guidanceTextClassName={s.guidanceText}
        labelClassName={s.inputLabel}
        inputClassName={s.input}
        facebookSectionClassName={s.facebookSection}
        facebookButtonProps={{
          className: s.facebookButton,
          bgColor: '#2c91e9',
          bgHoverColor: '#4f8cca',
        }}
        facebookSuccessMessage={
          <div className={s.facebookSuccessMessageContainer}>
            <img
              className={s.tickIcon}
              src={`${ASSET_PREFIX}/images/play-free-lp/complete-icon.svg`}
            />
            <div className={s.facebookSuccessMessage}>
              Facebook account verified.
              <br />
              Click below to enter competition.
            </div>
          </div>
        }
      />
    );

    if (desktopView) {
      return (
        <div
          className={s.container}
          style={{
            background: `url(${ASSET_PREFIX}/images/play-free-lp/oval-background-desktop.svg)`,
            backgroundSize: 'cover',
            backgroundPosition: '0% 50%',
            height: '100vh',
          }}
        >
          <PaddedMaxWidthContainer>
            <h1 className={s.title}>Sign up to enter</h1>

            {getRegisterForm()}

            <a
              href="https://uk.trustpilot.com/review/daymade.co.uk"
              rel="noreferrer"
              target="_blank"
              style={{
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                marginRight: '2em',
              }}
            >
              <img
                src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`}
                style={{ marginTop: '2.5em', width: '180px' }}
                alt="TrustPilot logo"
              />
            </a>
          </PaddedMaxWidthContainer>
        </div>
      );
    }

    return (
      <div
        className={s.container}
        style={{
          background: `url(${ASSET_PREFIX}/images/play-free-lp/oval-background-mobile.svg)`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <PaddedMaxWidthContainer>
          <h1 className={s.title}>Sign up to enter</h1>

          {getRegisterForm()}
        </PaddedMaxWidthContainer>
      </div>
    );*/
  }
);

export default PlayFreeSignUpAndEnter;
